import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import { eachDayOfInterval, isEqual, isSameMonth, lastDayOfWeek, startOfDay, startOfWeek } from 'date-fns';
import { useState } from 'react';
import CalendarCell from '../CalendarCell/index';
import { createSchedule } from '../utils/createSchedule';
const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
function WeekView(props) {
    const { schedule = [], date, isEditable, 
    // onEdit,
    source,
    // selectedPos,
    // onSelect
     } = props;
    const [showSchedule, setShowschedule] = useState();
    const scheduleDays = createSchedule(schedule);
    const weekRenderer = () => {
        return (_jsx(Box, Object.assign({ sx: {
                gridColumn: '1 / -1',
                display: 'grid',
                gridTemplateColumns: 'repeat(7, 1fr)',
                background: '#fff',
                borderRadius: '5px',
            } }, { children: weekdays.map((weekday) => (_jsx(Typography, Object.assign({ variant: "h3", sx: {
                    height: '40px',
                    display: 'grid',
                    justifyContent: 'right',
                    alignItems: 'center',
                    borderWidth: '1.5px',
                    borderStyle: 'solid',
                    borderColor: 'border.light',
                    paddingRight: '12px',
                    borderBottom: 'none'
                } }, { children: weekday }), weekday))) })));
    };
    const renderDays = () => {
        const daysInMonth = eachDayOfInterval({
            start: startOfWeek(date),
            end: lastDayOfWeek(date)
        });
        return daysInMonth.map((day, idx) => {
            let disabled = !isSameMonth(day, date);
            let isToday = isEqual(day, startOfDay(new Date()));
            let currentDaySchedule = scheduleDays[new Date(day).toDateString()];
            return (_jsx(Box, Object.assign({ sx: {
                    borderRight: '1.5px  solid #DCDFE4',
                    borderLeft: '1.5px  solid #DCDFE4',
                    borderBottom: '1.5px  solid #DCDFE4',
                    height: '55vh',
                } }, { children: _jsx(CalendarCell, { disabled: false, date: day, isToday: isToday, schedule: currentDaySchedule, isEditable: isEditable, showSchedule: showSchedule, setShowschedule: setShowschedule, cellType: "week", source: source }, idx) }), idx));
        });
    };
    return (_jsxs(Box, Object.assign({ sx: {
            gridColumn: '1 / -1',
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            marginTop: '12px',
            height: 'fit-content',
            margin: '10px 0px 0px'
        } }, { children: [weekRenderer(), renderDays()] })));
}
export default WeekView;
